import { add } from './math'

export const calculatePurchaseItemsValue = (data) =>
	Number(Number(data?.reduce((a, b) => add(a, b.price), 0)).toFixed(4) || 0)

export const priceWithSign = (price) => `${price} $`

export * from './date'
export * from './math'
